import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { OnboardingRoutingModule } from '@kp/onboarding/onboarding-routing.module';
import { ScreenLoginModule } from '@kp/screen-login/screen-login.module';
import { SharedModule } from '@kp/shared/shared.module';

@NgModule({
  declarations: [OnboardingRoutingModule.components],
  imports: [
    CommonModule,
    FormsModule,
    OnboardingRoutingModule,
    ReactiveFormsModule,
    RouterModule,
    ScreenLoginModule,
    SharedModule,
  ],
})
export class OnboardingModule {}
